export const MoveWidgetToSectionModalStyles = {
  width: '480px',
  margin: '0px auto',
  '& .modal-body': {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '0 24px 24px',
  },
};

export const MoveWidgetToSectionListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
};
